import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import TablaANDON from './TablaANDON';
import TablaProxCorridas from './TablaProxCorridas';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const andonTableEnabled = process.env.REACT_APP_ALLOW_ANDON_TABLE !== 'false';

export default function TabANDON() {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    if (!andonTableEnabled) {
        return (
            <div className="ANDONswitch">
                <p className="generalData-tittle-style prox-corridas-titulo">Próximas corridas</p>
                <TablaProxCorridas />
            </div>
        );
    }

    return (
        <div className="ANDONswitch">
            <AppBar position="static">
                <Tabs value={selectedTab} onChange={handleChange}>
                    <Tab label="Llamadas ANDON" />
                    <Tab label="Próximas corridas" />
                </Tabs>
            </AppBar>
            <TabPanel value={selectedTab} index={0}>
                <TablaANDON />
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <TablaProxCorridas />
            </TabPanel>
        </div>
    );
}
